// extracted by mini-css-extract-plugin
module.exports = {"hover":"categorical__hover___EpB01","value":"categorical__value___2RKaC"};